import { WorkspaceSchema } from "@common/schemas/workspace.schema";
import type { EntityAvatarGroupEntity } from "@components/avatar/EntityAvatarGroup";
import { HistoryEntityIconMap } from "./historyEntityMapContext";

type WorkspaceWithEntities = Pick<WorkspaceSchema, "entities">;

/**
 * Flattens the entities embedded in an organization's workspace list
 * (`useWorkspacesList({ includeEntities: true })`) into a single id → entity
 * lookup that History cells can use across workspaces.
 */
export function buildHistoryEntityMap(
    workspaces: WorkspaceWithEntities[],
): HistoryEntityIconMap {
    const entityIconsById = new Map<number, EntityAvatarGroupEntity>();
    for (const workspace of workspaces) {
        for (const entity of workspace.entities ?? []) {
            entityIconsById.set(entity.id, entity);
        }
    }
    return entityIconsById;
}
